import { LoaderListBullets } from "pro-features/components/Loaders/src/LoaderListItems";
import { i18nFilter } from "app/filters/i18nFilter";

export const Loader = () => (
    <LoaderListBullets
        title={i18nFilter()("keywordanalysis.graph.loader.title")}
        subtitle={i18nFilter()("keywordanalysis.graph.loader.subtitle")}
    />
);
